import React, { useRef } from 'react';
import './QuickQuestionList.sass';
import store from "../../../store";
import {useSelector} from "react-redux";
import {useGlobal} from "reactn";
import Actions from "../../../constants/Actions";
import messageClient from "../../../actions/messageClient";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const QuickQuestionList = ({quickQuestion}) => {
    const user = useGlobal('user')[0];
    const room = useSelector(state => state.io.room);
    const sliderRef = useRef(null);
    const isDragging = useRef(false);

    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        variableWidth: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        beforeChange: () => {
            isDragging.current = true;
        },
        afterChange: () => {
            setTimeout(() => {
                isDragging.current = false;
            }, 0);
        }
    };

    const handleClickQuickQuestion = (e, item) => {
        if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if(item?.type === 'text'){
            sendMessage(item?.payload);
        } else if (item?.type === 'link') {
            window.open(item?.payload, '_blank');
        }
    }

    const sendMessage = async (content) => {
        if (content.length === 0) return;

        let finalText = content.trim();
        let resMess;

        let messageData = { roomID: room._id, authorID: user.id, content: finalText, type: 'text', action : 'message', livechat_language: localStorage.getItem('livechat_language') || 'vi'};

        resMess = await messageClient(messageData);
        resMess = resMess?.data;

        if(!resMess){
            return;
        }

        let newMessage = resMess.data.message;

        if(resMess.error){
            newMessage = resMess.data.message;
            newMessage.error_message = resMess.message;
        }

        store.dispatch({type: Actions.MESSAGE, message: newMessage});
    };

    return (
        <div className="quick-question">
            <Slider ref={sliderRef} {...settings}>
                {quickQuestion && (
                    quickQuestion.map((question, index) => <div key={index} className="quick-question_item" onClick={(e) => handleClickQuickQuestion(e, question)}>
                        <span className="quick-question__name">{question?.title || ""}</span>
                    </div>)
                )}
            </Slider>
        </div>
    );
};

export default QuickQuestionList;
